<template>
  <!-- 二维码扫描登录组件 -->
  <div id="login">
    <div class="ewmLogin" v-show="isShow">
      <div class="ewmLoginDiv">
        <a href="javascript:;" class="closeEwmBtn" @click="closeEwmLogin">
          <img src="../ewmLogin/img/closeEwm.png" />
        </a>
        <div class="ewmImg">
          <img :src="ewmUrl" />
        </div>
        <a href="javascript:;" class="phoneLoginBtn" @click="phoneLogin">切换手机登录</a>
        <!-- <div class="inputDiv">
          <p>测试登录</p>
          <input type="text" v-model="phone">
          <button v-on:click="login">登陆</button>
        </div>-->
      </div>
      <div class="ewmCloseBg" @click="closeEwmLogin"></div>
    </div>
    <!-- 引入手机登录组件-start -->
    <phoneLogin ref="phoneLoginPart" v-on:ewmLoginBtn="goEwmLogin"></phoneLogin>
    <!-- 引入手机录组件-end -->
  </div>
</template>

<script>
import phoneLogin from "@/components/phoneLogin/phoneLogin.vue"; //手机登录组件
import { getVersion } from "@/api/requestUrl"; //公共js
import { setTimeout, setInterval, clearInterval } from "timers";
export default {
  name: "login",
  components: {
    phoneLogin
  },
  data() {
    return {
      isShow: this.ewmLoginShow, //组件与外部组件传值要用代理参数传参
      ewmUrl: "", //后台返回的微信登录二维码地址
      timeValState: true,
      // phone: "",
      isPhoneLoginLayShow: false
    };
  },
  props: {
    ewmLoginShow: Boolean,
    /* 进入页面时是否判断登录 */
    isLogin: Boolean
  },
  methods: {
    showLogin() {
      this.isShow = true;
      this.getEwmImg();
      this.$emit("showLogin");
    },
    //切换手机登录
    phoneLogin: function() {
      var that = this;
      that.isShow = false;
      that.$refs.phoneLoginPart.openPhoneLogin(); //切换手机登录
    },

    goEwmLogin: function() {
      var that = this;
      that.isShow = true;
      that.$refs.phoneLoginPart.closePhoneLogin(); //切换手机登录
    },

    login() {
      var that = this;
      that.requestApi({
        method: "get",
        url: "/api/login/phoneLogin/login",
        data: { phone: that.phone },
        then(data) {
          //elementUI提供的提示框
          that.$message({
            message: "登录成功",
            type: "success"
          });

          that.requestApi({
            method: "get",
            url: "/api/user/isBindingPhone",
            data: { phone: that.phone },
            then(data) {}
          });

          if(getVersion() == "dev"){
            that.$alert("温馨提示：测试版本数据仅限于通信行业，时间为2019年1月1日至2019年10月31日。", "提示", {
              confirmButtonText: "确定",
              callback: action => {
                setTimeout(() => {
                  window.location.reload(); //登录成功后刷新页面
                  // location.href = location.origin + location.pathname + "#/index";
                }, 1000);
              }
            });
          }else{
             setTimeout(() => {
                window.location.reload(); //登录成功后刷新页面
                // location.href = location.origin + location.pathname + "#/index";
              }, 2000);
          }
         
        },
        fail(data) {
          that.closeEwmLogin();
        }
      });
    },
    //关闭二维码登录弹窗
    closeEwmLogin: function() {
      var that = this;
      that.isShow = false;
      that.timeValState = false;
      this.$emit("closeEwmLogin");
    },

    //获取后台返回的二维码
    getEwmImg: function() {
      var that = this;
      that.requestApi({
        method: "get",
        url: "/api/qrCode/getLoginQrCodeTicketAndUrl",
        data: {},
        then(data) {
          if (data.data != null) {
            that.ewmUrl = data.data.url;
            //每隔3秒根据二维码ticket查询扫描状态
            console.log("ticket:" + data.data.ticket);
            let ticketCode = data.data.ticket; //后台返回的ticket
            that.timeValState = true;
            let timeVal = setInterval(() => {
              if (that.timeValState) {
                that.requestApi({
                  method: "get",
                  url: "/api/qrCode/loginStatus",
                  data: {
                    ticket: ticketCode
                  },
                  then(data) {
                    if (data.data == true) {
                      clearInterval(timeVal); //登录成功后将定时器停下
                      that.isShow = false;
                      that.timeValState = false;
                      //elementUI提供的提示框
                      that.$message({
                        message: "登录成功",
                        type: "success"
                      });
                      setTimeout(() => {
                        if (location.href.indexOf("restLogin") !== -1) {
                          // location.href =
                          //   location.origin + location.pathname + "#/index";
                          that.$router.push({
                            path: "/index" //跳转的路由
                          });
                        } else {
                          location.reload(); //登录成功后刷新页面
                        }
                      }, 2000);
                    }
                  },
                  fail(data) {
                    clearInterval(timeVal);
                  }
                });
              } else {
                clearInterval(timeVal);
              }
            }, 3000);
          } else {
          }
        }
      });
    }
  },
  //在Vue2中组件的props的数据流动改为了只能单向流动，即只能由组件外（调用组件方）通过组件的DOM属性attribute传递props给组件内，组件内只能被动接收组件外传递过来的数据，并且在组件内，不能修改由外层传来的props数据。
  /**
   * 手动实现props的双向绑定
   */
  watch: {
    ewmLoginShow(val) {
      if (val === true) {
        this.getEwmImg(); //执行获取后台返回的二维码方法
      }
      console.log("val:" + val);
      this.isShow = val; //新增ewmLoginShow的watch，监听变更并同步到closeEwmLogin上()
    },
    isLogin(val) {
      console.log(val);
      if (val === true) {
        var that = this;
        // 进入页面就判断是否登录
        that.requestApi({
          method: "get",
          url: "/api/user/userInfo",
          loginStatus(res, status) {
            that.getEwmImg(); //执行获取后台返回的二维码方法
            that.isShow = true;
            console.log("that.isShow:" + that.isShow);
          }
        });
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ewmLogin {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
}
.ewmLogin .ewmLoginDiv {
  position: relative;
  width: 342px;
  height: 348px;
  background: url(../ewmLogin/img/loginEwm.png) top left no-repeat;
  top: 50%;
  margin: -174px auto 0 auto;
  z-index: 1000;
  background-size: 342px;
}
.ewmLogin .ewmCloseBg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  background: rgba(0, 0, 0, 0.2);
}
.ewmLogin .closeEwmBtn img {
  position: absolute;
  top: 0;
  right: 47px;
}
.ewmLogin .ewmImg {
  width: 134px;
  height: 134px;
  background: #fff;
  position: absolute;
  top: 100px;
  left: 110px;
}
.ewmLogin .ewmImg img {
  width: 134px;
  height: 134px;
}
/*测试登录*/
.inputDiv {
  background: #fff;
  position: relative;
  z-index: 999;
  padding: 15px 20px;
  bottom: 150px;
  border-radius: 2px;
}
.inputDiv p {
  text-align: center;
  font-size: 16px;
  margin-bottom: 10px;
}
.inputDiv input {
  border: 1px solid #eaeaea;
  width: 100%;
  height: 26px;
  line-height: 26px;
  margin-bottom: 15px;
  text-indent: 10px;
}
.inputDiv button {
  background: linear-gradient(
    162deg,
    rgba(51, 107, 142, 1) 0%,
    rgba(25, 159, 175, 1) 100%
  );
  color: #fff;
  display: block;
  height: 30px;
  line-height: 30px;
  width: 150px;
  text-align: center;
  font-size: 14px;
  margin: 0 auto;
  border-radius: 5px;
  cursor: pointer;
}
.phoneLoginBtn {
  position: absolute;
  top: 265px;
  text-align: center;
  display: block;
  width: 342px;
  left: 0;
  font-size: 14px;
  color: #535353;
}
</style>



// WEBPACK FOOTER //
// src/components/ewmLogin/ewmLogin.vue